import { NX_GOOGLE_CLIENT_ID, NX_GOOGLE_API_KEY } from '@env/environment';

const SCOPES = 'https://www.googleapis.com/auth/drive.file';
const GOOGLE_PLATFORM_SCRIPT = 'https://apis.google.com/js/platform.js';

export class Googledrive {
  private static instance: Googledrive;

  static getInstance() {
    if (!Googledrive.instance) {
      Googledrive.instance = new Googledrive();
    }
    return Googledrive.instance;
  }

  private async init() {
    if (!window.gapi) {
      await new Promise((resolve) => {
        const script = document.createElement('script');
        script.async = true;
        script.defer = true;
        script.src = GOOGLE_PLATFORM_SCRIPT;
        script.onload = resolve;
        document.head.appendChild(script);
      });
    }

    if (!window.gapi.auth2) {
      await new Promise((resolve) => window.gapi.load('client:auth2', resolve));
    }

    if (!this.auth()?.isSignedIn) {
      await window.gapi.client.init({
        apiKey: NX_GOOGLE_API_KEY,
        clientId: NX_GOOGLE_CLIENT_ID,
        scope: SCOPES,
      });
    }
  }

  private auth() {
    return window.gapi.auth2.getAuthInstance();
  }

  private get accessToken() {
    const currentUser = this.auth().currentUser.get();
    if (currentUser.hasGrantedScopes(SCOPES)) {
      return currentUser.getAuthResponse(true).access_token;
    }
  }

  async getAccessToken() {
    await this.init();
    await this.auth().signIn();
    return this.accessToken;
  }
}
